import { emitHypotheticalEvent } from './emitter';

const track = (hypotheticalTracking) => {
  emitHypotheticalEvent({ promo_AosAvailability: [hypotheticalTracking] });
};

export default track;
